import { Box, Container } from '@mui/material';
import {
  ComingSoonHeader,
  EBooksPageHeader,
  FeaturedEBookSection,
  UpcomingEBooksSection,
} from '../components/EBooksPage/index.js';
import { useRsmTheme } from '../hooks/useTheme.js';
import { ContentPageLayout } from '../layouts';

/**
 * eBooks Page - Full page for reading/downloading eBooks
 *
 * @returns {React.ReactElement} eBooks page component
 */
function EBooksPage() {
  const { colors } = useRsmTheme();

  return (
    <ContentPageLayout backgroundColor={colors.backgroundLight}>
      <Box
        sx={{
          minHeight: '100vh',
          pt: 12,
          pb: 8,
        }}
      >
        <Container maxWidth="lg">
          <EBooksPageHeader />

          {/* COMMENTED OUT - Ready Book Content Template - Keep for future use
        When books are ready, uncomment this section and add DownloadIcon import
        This template provides the full book reading experience with chapters and download functionality
        END COMMENTED OUT READY BOOK TEMPLATE */}

          <FeaturedEBookSection />

          <ComingSoonHeader />

          <UpcomingEBooksSection />
        </Container>
      </Box>
    </ContentPageLayout>
  );
}

export default EBooksPage;
